






import Vue from 'vue'
import { format } from 'date-fns';

export default Vue.extend({
    data() {
        return {
            params: null as any
        }
    },
    computed: {
        value(): number | string {
            if (!this.params.value) {
                return '';
            }

            return format(new Date(this.params.value), this.params.format)
        }
    }
})
